/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import React from 'react';
import { StylesConfig } from 'react-select';
import ReactSelect from 'react-select/async';
import theme from '../../providers/theme-service';

interface Props {
  name: string;
  placeholder: string;
  value: any;
  onChange: any;
  loadOptions: (value: string) => void;
  noDataMessage: string;
  validate: boolean;
}

export type DataProps = {
  value: string;
  label: string;
};

const AsyncSelect = ({
  name,
  placeholder,
  value,
  onChange,
  loadOptions,
  noDataMessage,
  validate,
}: Props): JSX.Element => {
  const dropdownStyles: StylesConfig<DataProps, true> = {
    container: (provided) => ({
      ...provided,
      flexGrow: 1,
    }),
    option: (styles, {
      data, isDisabled, isFocused, isSelected,
    }) => ({
      ...styles,
      color: isDisabled
        ? '#2e2e2e'
        : isSelected
          ? theme.palette.primary.main
          : isFocused
            ? 'black'
            : '#444',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#848484',
    }),
    control: (provided) => ({
      ...provided,
      border: `1px solid ${!validate && 'red'}`,
      padding: '10px',
      borderRadius: '4px',
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#fff',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#1F2937',
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999
    }),
  };

  return (
    <ReactSelect
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      loadOptions={loadOptions}
      styles={dropdownStyles}
      noOptionsMessage={() => noDataMessage}
      loadingMessage={() => 'Carregando...'}
      menuPortalTarget={document.body}
      maxMenuHeight={220}
      menuPlacement="auto"
    />
  );
};

export default AsyncSelect;